export default __webpack_public_path__ + "static/dosBicicletasAzules-28d382faf03802a635d8171832f67c85.png";